export const NOTIFICATION_POLL_INTERVAL_MS = 30000;
